module.exports = require("./uk.d.ts");